import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efc8a9dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "计划日期", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = { class: "Search_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "单据类型", -1))
const _hoisted_7 = { class: "Search_item_content" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_search_x" }, null, -1))
const _hoisted_11 = { class: "content_total" }
const _hoisted_12 = { class: "content_list_out" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "content_list_item_top" }
const _hoisted_15 = { class: "content_list_item_top_left" }
const _hoisted_16 = { class: "content_list_item_top_right" }
const _hoisted_17 = {
  key: 0,
  class: "warning"
}
const _hoisted_18 = {
  key: 1,
  class: "green"
}
const _hoisted_19 = {
  key: 2,
  class: "info"
}
const _hoisted_20 = { class: "content_list_item_content" }
const _hoisted_21 = {
  style: {"margin-top":"0"},
  class: "content_list_item_content_item"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "单据类型：", -1))
const _hoisted_23 = { class: "content_list_item_content_item_nr" }
const _hoisted_24 = { class: "content_list_item_content_item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "出库仓库：", -1))
const _hoisted_26 = { class: "content_list_item_content_item_nr" }
const _hoisted_27 = { class: "content_list_item_content_item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划出库：", -1))
const _hoisted_29 = { class: "content_list_item_content_item_nr" }
const _hoisted_30 = { class: "content_list_item_content_item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "来源类型：", -1))
const _hoisted_32 = { class: "content_list_item_content_item_nr" }
const _hoisted_33 = { class: "content_list_item_content_item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "来源单号：", -1))
const _hoisted_35 = { class: "content_list_item_content_item_nr" }

import { reactive, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { gsdate } from "@/utils/utils";
// import { getList, pageCount } from "@/apis/PlanningAPI";
import { getBoundList, pageCount } from "@/apis/materialStorage";
import { judgmentPlatform } from "@/utils/utils";
import { model } from '@/interface'
import { orderTyepToStr } from '@/constData'
import vSearch from "@/components/common/Search.vue";
import vLableSelection from "@/components/common/LabelSelection.vue";

// 分页/查询-----接口
interface PagingType extends model {
  total: number;
  planDateEnd: string; // 计划转出开始时间
  planDateStart: string; // 计划转出结束时间
  code: string; // 转库单号
  status: string; // 状态
  originType: string; // 状态
}


// 分页/查询-----数据

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const listData = reactive<PagingType>({
  capacity: 10,
  page: 0,
  total: 0,
  planDateEnd: "",
  planDateStart: "",
  code: "",
  originType: "",
  status: "",
});

const router = useRouter();

const minDate: Date = new Date(new Date().getFullYear() - 1, 0, 1)

const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

// 来源单据类型  0采购订单、1生产工单、2销售订单、3转库单、4盘点单
let types: Array<{name: string, id: string, isActive: boolean }> = reactive(
[
    { name: '车间领料', id: '1', isActive: false },
    { name: '机台备料', id: '2', isActive: false },
    { name: '车间转库', id: '3', isActive: false },
    { name: '完工入库', id: '4', isActive: false },
    { name: '计划领料', id: '5', isActive: false },
    { name: '外协领料', id: '6', isActive: false },
    { name: '外协完工转库', id: '7', isActive: false },
    { name: '产品入库', id: '8', isActive: false },
    { name: '产品转库', id: '9', isActive: false },
    { name: '让步放行入库', id: '10', isActive: false },
    { name: '让步放行转库', id: '11', isActive: false },
    { name: '客返返修领料', id: '12', isActive: false },
    { name: '客返返修入库', id: '13', isActive: false },
    { name: '跨组织转库', id: '14', isActive: false },
    { name: '工序报废', id: '15', isActive: false },
    { name: '客退返修领料', id: '16', isActive: false },
    { name: '客退返修入库', id: '17', isActive: false },
    { name: '销售出库', id: '18', isActive: false },
    { name: '让步销售', id: '19', isActive: false },
    { name: '工单投料', id: '20', isActive: false },
    { name: '仓库报废', id: '21', isActive: false },
    { name: '客退检验领料', id: '22', isActive: false },
    { name: '客返检验领料', id: '23', isActive: false },
    { name: '库存调整', id: '28', isActive: false },
    { name: '废品入库', id: '30', isActive: false }
  ]
)



// 列表数据
let lists: any = ref([]);

// 控制打开日历插件
const isOpenDate = ref<boolean>(false);

// 根据平台是否需要设置top
let status = ref<boolean>(false);

const loading = ref<boolean>(false);
const finished = ref<boolean>(false);

// 搜索标签数据 0已生成、1已处理、2已取消
const tagList = reactive<Array<{ id: string; name: string; num: string }>>([
  {
    id: "",
    name: "全部",
    num: '0',
  },
  {
    id: "0",
    name: "待出库",
    num: '0',
  },
  {
    id: "1",
    name: "已出库",
    num: "0",
  },
  {
    id: "2",
    name: "已取消",
    num: "0",
  }
]);

const reset = () => {
  listData.code = '';
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  listData.planDateEnd = ''
  listData.planDateStart = ''
  listData.originType = ''
  types.forEach((item: {name: string, id: string, isActive: boolean }) => {
    item.isActive = false
  })
  getLists();
  getPageCount()
}

  // 统计数据
  const getPageCount = () => {
  pageCount({
    type: 0,
    codeOrHouse: listData.code,
    planDateEnd: listData.planDateEnd,
    planDateStart: listData.planDateStart,
    billType: listData.originType
  })
  .then((res: any) => {
    if (res.code === 200) {
      tagList[0].num = res.data.allNum.toString()
      tagList[1].num = res.data.startNum.toString()
      tagList[2].num = res.data.endNum.toString()
      tagList[3].num = res.data.cancelNum.toString()
    }
  })
}

onMounted(() => {
  status.value = judgmentPlatform();
  getPageCount()
  listData.page = 0
});

// 切换分类
const clickTag = (val: string) => {
  console.log(val)
  listData.status = val
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  getLists()
}

// 获取列表统计
// const pageCounts = () => {
//   pageCount({}).then((res) => {
//     if (res.code === 200 && res.data) {
//       tagList[0].num = res.data.allNum;
//       tagList[1].num = res.data.startNum;
//       tagList[2].num = res.data.ingNum;
//       tagList[3].num = res.data.endNum;
//     }
//   });
// };

const tyepToStr = (type: number): string => {
  //  <!-- 1、车间领料；2、车间备料；3、其他；4、完工入库 -->
  for (const item of types) {
    if (parseInt(item.id) === type) {
      return item.name
    }
  }
  return '-'
}


const loadData = (): void => {
  getLists()
}

// 获取计划列表数据
const getLists = (): void => {
  if (!finished.value) {
    loading.value = true;
    listData.page = listData.page + 1;
    getBoundList({
      capacity: listData.capacity,
      model: {
        type: 0,
        codeOrHouse: listData.code,
        planDateEnd: listData.planDateEnd,
        planDateStart: listData.planDateStart,
        status: listData.status,
        billType: listData.originType
      },
      page: listData.page,
      sorts: [
        {
          direction: "ASC",
          property: "publishDate",
        },
      ],
    })
      .then((res: any) => {
        loading.value = false;
        listData.total = res.data.total;
        if (res.code === 200) {
          if (listData.page === 1) {
            lists.value = res.data.records;
          } else {
            if (lists.value.length === res.data.total) {
              finished.value = true;
              return
            }
            lists.value.push(...res.data.records);
          }
        }
      })
      .finally(() => {
        loading.value = false;
      })
      .catch(err => {
        finished.value = true;
        loading.value = false;
      })
  }
};

// 接收子组件传来的输入框值
const searchInput = (val: string): void => {
  listData.code = val;
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  getLists();
  getPageCount()
}

// 搜索弹框提交
const submit = (): void => {
  listData.page = 0;
  finished.value = false;
  lists.value = [];
  getLists();
  getPageCount()
};

// 打开日期插件
const openDate = (): void => {
  isOpenDate.value = true;
};

// 确认选择时间
const onConfirm = (values: any): void => {
  const [start, end] = values;
  listData.planDateStart = gsdate(start);
  listData.planDateEnd = gsdate(end);
  isOpenDate.value = false;
};

// 切换工序
const changeTag = (i: any): void => {
  console.log(i);

  types[i].isActive = !types[i].isActive;
  listData.originType = types[i].id
  for (const index in types) {
    if (index != i) {
      console.log(index, i)
      const item = types[index]
      item.isActive = false
    }
  }
};

// 跳转详情
const jump = (item: any): void => {
  router.push({ name: "wOutboundDetail", query: { id: item.id } });
};

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ content_top: _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        ref: "Search",
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true,
        placeholder: "搜索出库单号/出库仓库"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "Search_item_content",
              onClick: openDate
            }, [
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(listData).planDateStart ? 'color: #000' : '')
              }, _toDisplayString(_unref(listData).planDateStart ? _unref(listData).planDateStart : "开始日期"), 5),
              _hoisted_4,
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(listData).planDateEnd ? 'color: #000' : '')
              }, _toDisplayString(_unref(listData).planDateEnd ? _unref(listData).planDateEnd : "结束日期"), 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", { tag_active: item.isActive }]),
                    key: item.id,
                    onClick: ($event: any) => (changeTag(i))
                  }, _toDisplayString(item.name), 11, _hoisted_9))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 512),
      _hoisted_10,
      _createVNode(vLableSelection, {
        TagList: _unref(tagList),
        isShow: true,
        onChange: clickTag
      }, null, 8, ["TagList"])
    ], 2),
    _createElementVNode("div", _hoisted_11, "共" + _toDisplayString(_unref(listData).total) + "条数据", 1),
    _createVNode(_component_van_list, {
      loading: loading.value,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
      finished: finished.value,
      "finished-text": "没有更多了~",
      onLoad: loadData
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lists), (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content_list_item",
              key: i,
              onClick: ($event: any) => (jump(item))
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(item.code), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (item.status === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "待出库"))
                    : (item.status === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "已出库"))
                      : (item.status === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已取消"))
                        : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(orderTyepToStr)(item.billType)), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString(item.warehouseName + ' | ' + item.warehouseCode), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, _toDisplayString(item.planDate), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, _toDisplayString(tyepToStr(item.originType)), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, _toDisplayString(item.originCode ? item.originCode : '-'), 1)
                ])
              ])
            ], 8, _hoisted_13))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["loading", "finished"]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((isOpenDate).value = $event)),
      type: "range",
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      onConfirm: onConfirm,
      color: "#4275FC"
    }, null, 8, ["show", "min-date", "max-date"])
  ]))
}
}

})